import { classes as htmlClasses } from 'html-classes';
import { observer } from 'mobx-react-lite';

import { Typography } from '@workspace/ui/components/Typography';

import { company } from '~/company/Company';
import { createCategoryUrl } from '~/components/CategoryBlocks/utils';
import { useGlobal } from '~/hooks/useGlobal';

import { Card } from '../shared/Card';
import { GridView, resolveTileSpans, tileClassNames } from '../shared/GridView';
import type { BlockCommonProps } from '../shared/interfaces';
import { ViewAllButton } from '../shared/ViewAllButton';
import styles from './CategoriesGrid2M.module.scss';

const CategoriesGrid2M = ({
  category,
  classes,
  priority = false,
}: BlockCommonProps) => {
  const { root: className, titleClassName } = classes || {};
  const { subcategory = [] } = category;
  const { isMobile } = useGlobal();

  const TitleComponent = isMobile
    ? Typography.Header100Medium
    : Typography.Header400Medium;

  return (
    <div className={htmlClasses([styles.root, className])}>
      {subcategory.map((subCategory, index) => (
        <div className={styles.section} key={subCategory.id}>
          <div className={styles.head}>
            <TitleComponent
              as="h3"
              className={htmlClasses([styles.title, titleClassName])}
            >
              {subCategory.name}
            </TitleComponent>
            <ViewAllButton link={createCategoryUrl({ id: subCategory.id })} />
          </div>

          <GridView>
            {subCategory.subcategory.map((item, itemIndex) => {
              const tileSize = company.tileSizeEnabled
                ? resolveTileSpans(item.tileSize)
                : 1;

              return (
                <Card
                  key={item.id}
                  category={item}
                  tileSize={tileSize}
                  priority={priority && index === 0 && itemIndex === 0}
                  classes={{ tileClassName: tileClassNames[tileSize] }}
                />
              );
            })}
          </GridView>
        </div>
      ))}
    </div>
  );
};

export default observer(CategoriesGrid2M);
